import { ensure } from 'components/sharpr/ensure/ensure';
import { makeCacheable } from 'components/sharpr/makeCacheable/makeCacheable';

export function filterByStringFilter() {
	'ngInject';
	return makeCacheable((array, field, searchText) => {
		searchText = String(searchText).toLocaleLowerCase();
		const toSearch = ensure.array(array);
		if (searchText === '') {
			return toSearch.slice(0);
		}
		return toSearch.filter(item => {
			return String(item[field]).toLocaleLowerCase().indexOf(searchText) > -1;
		});
	});
}
